if (!customElements.get('void-shipping-progress')) {
  class VoidShippingProgress extends HTMLElement {
    stateVersion = 0;
    static pendingCart = null;
    static getCart() {
      if (!this.pendingCart) {
        const root = window.Shopify?.routes?.root || '/';
        this.pendingCart = fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then((response) => { if (!response.ok) throw new Error('Cart unavailable'); return response.json(); })
          .finally(() => { this.pendingCart = null; });
      }
      return this.pendingCart;
    }
    connectedCallback() {
      this.update(Number(this.dataset.total), null);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (Number.isFinite(event?.cartData?.total_price)) {
            this.update(event.cartData.total_price, event.cartData.item_count);
          } else {
            this.refresh();
          }
        });
      }
      this.onPageShow = () => this.refresh();
      window.addEventListener('pageshow', this.onPageShow);
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      window.removeEventListener('pageshow', this.onPageShow);
    }
    async refresh() {
      const version = this.stateVersion;
      try {
        const cart = await VoidShippingProgress.getCart();
        if (!this.isConnected || version !== this.stateVersion) return;
        if (cart.currency !== this.dataset.currency) { this.hidden = true; return; }
        this.hidden = false;
        this.update(cart.total_price, cart.item_count);
      } catch {
        this.refreshFailed = true;
      }
    }
    update(total, itemCount) {
      const threshold = Number(this.dataset.threshold);
      if (!Number.isFinite(total) || !Number.isFinite(threshold) || threshold <= 0) return;
      this.stateVersion += 1;
      const remaining = Math.max(0, threshold - total);
      const bar = this.querySelector('progress');
      const message = this.querySelector('.void-shipping-progress__message');
      bar.value = Math.min(threshold, Math.max(0, total));
      this.toggleAttribute('data-complete', remaining === 0);
      const amount = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency }).format(remaining / 100);
      message.textContent = itemCount === 0 || total === 0 ? this.dataset.empty : remaining === 0 ? this.dataset.unlocked : this.dataset.remaining.replace('[amount]', amount);
      this.dataset.total = String(total);
    }
  }
  customElements.define('void-shipping-progress', VoidShippingProgress);
}

